import { createFileRoute } from '@tanstack/react-router';
import { EventsPage } from '@web/modules/campaigns/events/events-page';

export const Route = createFileRoute('/_app/campaigns/events/')({
  component: EventsPage,
});
